import React from 'react';
// import ReactDOM from 'react-dom';
import { render } from 'react-snapshot';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import ScrollToTop from './ScrollToTop';

import { ContextProvider as Provider } from './Context';
import { ModalContextProvider } from './ModalContext';

render(
  <Provider>
    <ModalContextProvider>
      <Router>
        <ScrollToTop />
        <App />
      </Router>
    </ModalContextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
